import type { ChangeEvent } from 'react';
import { BaseFilterDropdown } from './BaseFilterDropdown';

type InputDropdownProps = {
  title: string;
  value: string | number;
  isOpen: boolean;
  onToggle: () => void;
  onChange: (value: string | number) => void;
  type?: 'text' | 'number';
  step?: number;
  min?: number;
  max?: number;
};

export function FilterDropdownInput({
  title,
  value,
  isOpen,
  onToggle,
  onChange,
  type = 'text',
  step = 1,
  min = 0,
  max = 100,
}: InputDropdownProps) {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;

    if (type === 'number') {
      if (inputValue === '') {
        onChange('');
      } else {
        const numValue = Number(inputValue);
        if (!Number.isNaN(numValue) && numValue >= min && numValue <= max) {
          onChange(numValue);
        }
      }
    } else {
      onChange(inputValue);
    }
  };

  return (
    <BaseFilterDropdown
      title={title}
      isOpen={isOpen}
      onToggle={onToggle}
      selectedCount={value ? 1 : 0}
    >
      <div className="p-[8px]">
        <input
          type={type}
          value={value === 0 ? '' : value}
          step={step}
          min={min}
          max={max}
          onChange={handleChange}
          className="w-full rounded-[4px] border border-[#D4D6EC] p-2 outline-none focus:border-[#606384]"
          placeholder={`Enter ${title.toLowerCase()}`}
        />
      </div>
    </BaseFilterDropdown>
  );
}
